module.exports = __webpack_public_path__ + "img/ring_g_0_0_0@2x.f13145e0.png";